import { useEffect, useRef } from 'react'

/**
 * Runs effect with delay.
 *
 * Can be used to bebounce effect execution, as it clears timeout on rerun
 */
export const useDelayedEffect = (cb: () => void | (() => void), delay: number, deps: any[], skipFirst?: boolean) => {
  const first = useRef<boolean>(true)
  useEffect(() => {
    if (first.current && skipFirst) {
      first.current = false
      return
    }

    let cleanup: null | (() => void) = null
    const t = setTimeout(() => {
      cleanup = cb() || null
    }, delay)
    return () => {
      clearInterval(t)
      if (cleanup) cleanup()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay, ...deps])
}
